<template>
    <div
            class="formulas-block"
            v-click-outside="hideDropdown"
    >
        <div class="formulas-block-button">
            <VButton
                    :is-active="isShowFormulaDropdown"
                    @click="changeVisibilliy"
            ><span class="bold">Formulas</span>
            </VButton>
        </div>
        <div
                class="formulas-block-dropdown"
                :style="dropdownHeight"
                v-if="isShowFormulaDropdown"
        >
            <div class="formulas-block-dropdown-item formulas-block-dropdown-item__template">
                <FormulasBlockTemplates
                        :formulas="formulas"
                        :templates="templates"
                        @addFormula="addFormula"
                        @deleteFormula="deleteFormula"
                        @addAllFormulas="addAllFormulas"
                />
            </div>
            <div
                    class="formulas-block-name"
            >
                <span>Custom Formulas:</span><span> <VButton v-if="localCustomFormulas.length" type="button"
                                                             theme="positive" style="width: 110px;"
                                                             @click="clearAllCustomFormulas">Clear all</VButton></span>
            </div>
            <draggable
                    :list="localCustomFormulas"
                    @change="swapFormulas"
                    class="Events-block-draggable"
                    :disabled="isSomeFormulasInEditMode"
            >
                <div
                        class="formulas-block-dropdown-item"
                        v-for="(formula,formulaIndex) in localCustomFormulas"
                        :key="formulaIndex"
                >
                    <span
                            class="formulas-block-dropdown-item-row"
                            v-show="formula.isEdit"
                    >
                    <VInput
                            class="short-input"
                            :class="{invalid:!formula.isNameValid}"
                            @change="validateLocalFormulaName(formulaIndex,false)"
                            v-model="formula.name"
                    ></VInput>
                     <span class="formulas-block-dropdown-item__sign-equally">
                    =
                </span>
                    <VCombobox
                            class="long-input"
                            :class="{invalid:!formula.isEquationValid}"
                            v-model="formula.equation"
                            @change="validateLocalFormulaEquation(formulaIndex,false)"
                            placeholder="100*install/subscription"
                            :search-items="searchOptions"
                            @enter="allowEditFormula(formulaIndex,formula,false)"
                    ></VCombobox>
                    <span
                            class="formulas-block-dropdown-item__allow-edit_apply"
                            @click="allowEditFormula(formulaIndex,formula,false)"
                    >
                    </span>
                </span>
                    <span
                            class="formulas-block-dropdown-item-row"
                            v-show="!formula.isEdit"
                    >
                        <span
                                class="formulas-block-dropdown-item__draggable"
                                :class="{disabled:isSomeFormulasInEditMode}"
                        >
                            ...
                        </span>
                    <span class="formulas-block-dropdown-item-row__left-side">
                        <span
                                class="formulas-block-dropdown-item__delete"
                                @click="deleteFormula(formula,formulaIndex)"
                        >
                        </span>
                        <span class="formulas-block-dropdown-item__text">
                            <span>
                                {{ formula.name }}
                            </span>
                        </span>
                    </span>
                    <span class="formulas-block-dropdown-item__sign-equally">=</span>
                    <span class="formulas-block-dropdown-item-row__right-side">
                        <span>
                            {{ formula.equation }}
                        </span>
                        <span
                                v-if="!formula.isTemplate"
                                class="formulas-block-dropdown-item__allow-edit"
                                @click="allowEditFormula(formulaIndex,formula,true)"
                        >
                        </span>
                    </span>
                </span>
                </div>
            </draggable>
            <div class="formulas-block-dropdown-item">
                <VInput
                        class="short-input"
                        placeholder="Name"
                        ref="addFormulaName"
                        @change="validateNewFormulaName(false)"
                        :class="{invalid:!newFormula.isNameValid}"
                        v-model="newFormula.name"
                ></VInput>
                <span class="formulas-block-dropdown-item__sign-equally">
                    =
                </span>
                <VCombobox
                        class="long-input"
                        v-model="newFormula.equation"
                        @change="validateNewFormulaEquation(false)"
                        :class="{invalid:!newFormula.isEquationValid}"
                        placeholder="100*install/subscription"
                        :search-items="searchOptions"
                        @enter="addFormula(newFormula)"
                ></VCombobox>
                <span
                        class="formulas-block-dropdown__add-formula"
                        @click="addFormula(newFormula)"
                >
                </span>
            </div>
            <!--            <div class="formulas-block-dropdown-item all-features">-->
            <!--                <span>-->
            <!--                All features:-->
            <!--                <v-checkbox-->
            <!--                    :checked="areAllFeatures"-->
            <!--                    @click="updateAreAllFeatures"-->
            <!--                ></v-checkbox></span>-->
            <!--                <span> <VFilter-->
            <!--                    v-model="choosedFeatures"-->
            <!--                    :options="featuresOptions"-->
            <!--                    :disabled="areAllFeatures"-->
            <!--                    show-property="name"-->
            <!--                    unique-property="name"-->
            <!--                    title="choose features"-->
            <!--                ></VFilter></span>-->
            <!--            </div>-->


            <div class="formulas-block-footer">
                <VButton
                        type="button"
                        theme="positive"
                        @click="copyFormulasAndEventsNotification"
                >
                    Copy events and formulas
                </VButton>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import FormulasBlockTemplates from './FormulasBlock/FormulasBlockTemplates';
import {eventBus} from '../../main';
import apiBoards from '../../api/apiBoards';

export default {
    name: 'FormulasBlock',
    components: {
        draggable,
        FormulasBlockTemplates,
    },
    props: {
        formulas: {
            type: Array,
            required: true,
        },
        templates: {
            type: Array,
            required: true,
        },
        allEvents: {
            type: Array,
            required: true,
        },
        boards: {
            type: Array,
            required: true,
        },
        isShowTopPanel: {
            type: Boolean,
            required: true,
        },
        currentBoard: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isShowFormulaDropdown: false,
            newFormula: {
                name: '',
                equation: '',
                isActive: true,
                isEquationValid: true,
                isNameValid: true,
            },
            localFormulas: [],
            isNeedUpdateBoard: false,
            areAllFeatures: true,
            choosedFeatures: [],
        };
    },
    computed: {
        featuresOptions() {
            return this.currentBoard.featuresData.map((feature) => {
                return {
                    name: feature.name,
                };
            });
        },
        searchOptions() {
            // const summaryFeature = this.currentBoard.featuresData.find(({name}) => name === 'Summary');
            // const summaryAPPRU = summaryFeature.rows.map((row) => `summary${row.value}`);
            return this.allEventsNames.concat(Object.values(this.searchOptionsAdditional).reduce((acc, currentOptions) => {
                return acc.concat(currentOptions);
            }, []));
        },
        searchOptionsAdditional() {
            return {summary: ['coef']};
        },
        allEventsNames: function () {
            return Object.freeze(this.allEvents.map((event) => event.name));
        },
        isSomeFormulasInEditMode() {
            return this.localFormulas.some((formula) => formula.isEdit);
        },
        templateNames() {
            return this.templates.map((formula) => formula.name);
        },

        localCustomFormulas() {
            return this.localFormulas.filter((formula) => !this.templateNames.includes(formula.name));
        },
        dropdownHeight() {
            return this.isShowTopPanel ? {'max-height': 'calc(100vh - 186px)'} : {'max-height': 'calc(100vh - 123px)'};
        },
    },
    watch: {
        formulas: {
            immediate: true,
            deep: true,
            handler() {
                this.init();
            },
        },
    },
    created() {
        eventBus.$on('VNotification-copy-events-and-formulas', this.copyFormulasAndEvents);
        eventBus.$on('FormulasBlockUpdateArppuCoef', this.updateCoefFormulas);
    },
    beforeDestroy() {
        eventBus.$off('VNotification-copy-events-and-formulas', this.copyFormulasAndEvents);
        eventBus.$off('FormulasBlockUpdateArppuCoef', this.updateCoefFormulas);
    },
    methods: {
        init() {
            this.localFormulas = this.formulas.map((formula) => {
                const newFormula = _.cloneDeep(formula);
                newFormula.isEdit = false;
                newFormula.isNameValid = true;
                newFormula.isEquationValid = true;
                return newFormula;
            });
            this.newFormula = {
                name: '',
                equation: '',
                isActive: true,
                isEquationValid: true,
                isNameValid: true,
            };
        },
        copyFormulasAndEvents() {
            this.boards.forEach((board) => {
                if (board.id !== this.currentBoard.id) {
                    const sourceAllowedEventsNames = board.currentSource.events.map(({name}) => name);
                    const forbiddenEventNames = [];
                    const forbiddenEventNamesIndexes = [];
                    this.currentBoard.events.forEach((event, eventIndex) => {
                        if (!sourceAllowedEventsNames.includes(event.name)) {
                            forbiddenEventNames.push(event.name);
                            forbiddenEventNamesIndexes.push(eventIndex);
                        }
                    });
                    board.featuresData = _.cloneDeep(board.featuresData).map((feature) => {
                        feature.deletedIndexes = feature.deletedIndexes.filter((index) => {
                            const event = board.allEvents[index];
                            return !forbiddenEventNames.includes(event.name);
                        });
                        return feature;
                    });
                    board.allEvents = _.cloneDeep(this.currentBoard.allEvents).filter((event) => !forbiddenEventNames.includes(event.name));
                    board.events = _.cloneDeep(this.currentBoard.events).filter((event) => !forbiddenEventNames.includes(event.name));
                    board.eventsOrder = _.cloneDeep(this.currentBoard.eventsOrder).filter((name) => !forbiddenEventNames.includes(name));
                    board.formulas = _.cloneDeep(this.currentBoard.formulas);
                    board.allFormulas = _.cloneDeep(this.currentBoard.allFormulas);
                    board.deletedFormulas = _.cloneDeep(this.currentBoard.deletedFormulas);
                    board.deletedEvents = _.cloneDeep(this.currentBoard.deletedEvents).filter((event) => !forbiddenEventNames.includes(event.name));
                    board.allEventsAndAllFormulas = {...board.allEvents, ...board.allFormulas};
                    board.deletedEventsAndFormulasIndexes = _.cloneDeep(this.currentBoard.deletedEventsAndFormulasIndexes).filter((index) => !forbiddenEventNamesIndexes.includes(index));
                    board.isFirstTimeLoaded = false;
                    apiBoards.updateBoard(board, true);
                }
            });
        },
        copyFormulasAndEventsNotification() {
            const notification = {};
            notification.confirmText = 'Copy';
            notification.eventConfirm = 'VNotification-copy-events-and-formulas';
            notification.contentText = '';
            notification.headerText = `Are you sure want to copy events and formulas?`;
            eventBus.$emit('VNotificationShow', notification);
        },
        swapFormulas(swapObject) {
            const templatesCount = this.localFormulas.length - this.localCustomFormulas.length;
            console.log('templatesCount', _.cloneDeep(templatesCount));
            const firstIndex = swapObject.moved.oldIndex + templatesCount;
            const secondIndex = swapObject.moved.newIndex + templatesCount;
            this.$emit('swapFormulas', firstIndex, secondIndex);
        },
        changeVisibilliy() {
            this.isShowFormulaDropdown = !this.isShowFormulaDropdown;
            if (this.isShowFormulaDropdown) {
                this.isNeedUpdateBoard = false;
                this.init();
            } else if (!this.isShowFormulaDropdown && this.isNeedUpdateBoard) {
                this.$emit('updateStateForBoards');
                this.isNeedUpdateBoard = false;
            }
        },
        hideDropdown() {
            this.isShowFormulaDropdown = false;
            if (this.isNeedUpdateBoard) {
                this.$emit('updateStateForBoards');
                this.isNeedUpdateBoard = false;
            }
        },
        allowEditFormula(customFormulaIndex, oldFormula, bool) {
            const formulaIndex = this.localFormulas.findIndex((formula) => formula.name === oldFormula.name);
            if (bool) {
                this.localFormulas[formulaIndex].isEdit = bool;
            } else if (!bool && this.localFormulas[formulaIndex].equation.trim().length && this.localFormulas[formulaIndex].name.trim().length) {
                this.updateFormula(formulaIndex);
                this.localFormulas[formulaIndex].isEdit = bool;
            }
            if (!bool) {
                this.validateLocalFormulaName(formulaIndex, true);
                this.validateLocalFormulaEquation(formulaIndex, true);
            }

        },
        updateAreAllFeatures() {
            this.areAllFeatures = !this.areAllFeatures;
        },
        clearAllCustomFormulas() {
            this.localCustomFormulas.forEach((formula) => {
                this.deleteFormula(formula);
            })
        },
        addAllFormulas(formulas){
            console.log('formulas', _.cloneDeep(formulas));
            this.$emit('addAllFormulas', formulas);
        },
        addFormula(newFormulaArg) {
            let newFormula = _.cloneDeep(newFormulaArg);
            const isNotEmptyName = !!newFormula.name.length;
            const formulasNames = this.localFormulas.map(({name}) => name);
            const isNewName = !formulasNames.includes(newFormula.name);

            if (isNotEmptyName && isNewName && newFormula.equation.length) {
                delete newFormula.isEquationValid;
                delete newFormula.isNameValid;
                newFormula = this.assignAdditionalFormulaData(newFormula);

                this.$emit('addCurrentFormula', newFormula);
                this.newFormula = {
                    name: '',
                    equation: '',
                    isActive: true,
                    isEquationValid: true,
                    isNameValid: true,
                };
                this.isNeedUpdateBoard = true;
                if(!newFormulaArg.isTemplate){
                    this.$refs.addFormulaName.$el.querySelector('input').focus();
                }
                this.newFormula.isEquationValid = true;
                this.newFormula.isNameValid = true;
            } else {
                this.validateNewFormulaName(true);
                this.validateNewFormulaEquation(true);
            }

        },
        deleteFormula(formula) {
            this.$emit('deleteCurrentFormula', formula);
            this.isNeedUpdateBoard = true;
        },
        assignAdditionalFormulaData(formula) {
            const newFormula = _.cloneDeep(formula);
            if (!this.areAllFeatures) {
                newFormula.featuresNames = this.choosedFeatures.reduce((features, currentFeatureObj) => {
                    features[currentFeatureObj.name] = true;
                    return features;
                }, {});
                newFormula.isAdditionalColumn = true;
            } else {
                newFormula.isAdditionalColumn = false;
            }
            const currentFeatures = Object.entries(this.searchOptionsAdditional).reduce((acc, [featureName, options]) => {
                if (options.some((option) => newFormula.equation.toLowerCase().trim().includes(option.toLowerCase()))) {
                    return acc.concat(featureName);
                }
                return '';
            }, []);
            newFormula.isCurrentFeatureAdditionalColumn = !!currentFeatures.length;
            newFormula.currentFeatures = currentFeatures;
            return newFormula;
        },
        updateCoefFormulas(){
          this.localFormulas.forEach((formula,formulaIndex)=>{
            if(formula.equation.includes('coef')){

              this.updateFormula(formulaIndex, true);
            }

          })
        },
        updateFormula(formulaIndex,isForceUpdate = false) {
            if (isForceUpdate || this.localFormulas[formulaIndex].equation.trim() !== this.formulas[formulaIndex].equation.trim()) {
                let newFormula = this.formulas[formulaIndex];
                newFormula.equation = this.localFormulas[formulaIndex].equation;
                newFormula = this.assignAdditionalFormulaData(newFormula);
                this.$emit('updateCurrentFormula', formulaIndex, newFormula,
                    this.formulas[formulaIndex].name, this.localFormulas[formulaIndex].name);
                this.isNeedUpdateBoard = true;
            }
            if (this.localFormulas[formulaIndex].name.trim() !== this.formulas[formulaIndex].name.trim()) {
                this.$emit('updateCurrentFormulaName', formulaIndex,
                    this.formulas[formulaIndex].name, this.localFormulas[formulaIndex].name);
                this.isNeedUpdateBoard = true;
            }
        },
        validateLocalFormulaName(formulaIndex, clicked) {
            this.$nextTick(() => {
                if (clicked) {
                    this.localFormulas[formulaIndex].isNameValid = !!this.localFormulas[formulaIndex].name.length;
                } else {
                    this.localFormulas[formulaIndex].isNameValid = true;
                }
                this.$forceUpdate();
            });
        },
        validateLocalFormulaEquation(formulaIndex, clicked) {
            this.$nextTick(() => {
                if (clicked) {
                    this.localFormulas[formulaIndex].isEquationValid = !!this.localFormulas[formulaIndex].equation.length;
                } else {
                    this.localFormulas[formulaIndex].isEquationValid = true;
                }
                this.$forceUpdate();
            });
        },
        validateNewFormulaName(clicked) {
            this.$nextTick(() => {
                if (clicked) {
                    const isNotEmptyName = !!this.newFormula.name.length;
                    const formulasNames = this.localFormulas.map(({name}) => name);
                    const isNewName = !formulasNames.includes(this.newFormula.name);

                    this.newFormula.isNameValid = isNotEmptyName && isNewName;
                } else {
                    this.newFormula.isNameValid = true;
                }
            });
        },
        validateNewFormulaEquation(clicked) {
            this.$nextTick(() => {
                if (clicked) {
                    this.newFormula.isEquationValid = !!this.newFormula.equation.length;
                } else {
                    this.newFormula.isEquationValid = true;
                }
            });
        },
    },
};
</script>

<style
    scoped
    lang="scss"
>
::v-deep {
  .short-input {
    input {
      width: 111px;
    }
  }

  .long-input {
    input {
      width: 176px;
    }
  }
}

.formulas-block {
  position: relative;

  .all-features {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: 30px;

    span {
      display: flex;
      align-items: center;
    }
  }

  ::v-deep {
    .VCombobox {
      .VInput-wrapper {
        display: flex;
      }
    }

    .VCombobox-dropdown {
      text-align: left;
    }
  }

  &-name {
    text-align: left;
    font-weight: bold;
    padding-top: 10px;
    padding-bottom: 10px;
    display: flex;
    justify-content: space-between;

  }

  &-dropdown {
    position: absolute;
    z-index: $dropdown-z-index;
    background: #fff;
    width: 385px;
    padding: 9px 11px 10px 15px;
    border-radius: 5px 0 5px 5px;
    overflow: auto;
    @include scrollbar-styles;
    @include dark-shadow;

    &__add-formula {
      width: 17px;
      height: 17px;
      cursor: pointer;

      background-position: 0 0;
      background-repeat: no-repeat;
      background-image: url('data:image/svg+xml;base64,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');
    }


    &-item {
      display: flex;
      align-items: center;
      padding: 5px 0;
      font-weight: 500;

      &__template {
        display: flex;
        justify-content: space-between;
      }

      &__draggable {
        cursor: pointer;
        color: $secondary-color;
        display: flex;
        font-size: 26px;
        writing-mode: vertical-lr;
      }

      &__text {
        width: 76px;
        display: flex;

        span {
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      &-row {
        display: flex;
        align-items: center;

        &__left-side {
          display: flex;
        }

        &__right-side {
          display: flex;
          width: 216px;
          justify-content: space-between;
        }
      }

      &__allow-edit {
        padding-left: 2px;
        cursor: pointer;
        width: 10px;
        min-width: 10px;
        height: 16px;
        background-position: 0 0;
        background-repeat: no-repeat;
        background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjEycHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDEyIDE2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBza2V0Y2h0b29sIDU1LjIgKDc4MTgxKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4NCiAgICA8dGl0bGU+OTFEM0FFQ0UtMjU4RS00N0JBLUI1NEQtNUE5N0I5MURGNTkwQDEsNXg8L3RpdGxlPg0KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4NCiAgICA8ZyBpZD0iUGFnZS00IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4NCiAgICAgICAgPGcgaWQ9Ik1haW5fcGxhaW5fb3Blbl9mb3JtdWxhIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjIuMDAwMDAwLCAtMTIuMDAwMDAwKSIgZmlsbD0iIzAyREZCMCIgc3Ryb2tlPSIjNjA4OUU3Ij4NCiAgICAgICAgICAgIDxnIGlkPSJtZW51X3RvcCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUuMDAwMDAwLCA5LjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxnIGlkPSJ0YWJfb3BlbiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDUuMDAwMDAwLCAyLjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iaWNvbi9wZW4iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCAxLjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTUuNSwxMS41IEw5LjUsMTEuNSBMOS41LDIgQzkuNSwxLjE3MTU3Mjg4IDguODI4NDI3MTIsMC41IDgsMC41IEw3LDAuNSBDNi4xNzE1NzI4OCwwLjUgNS41LDEuMTcxNTcyODggNS41LDIgTDUuNSwxMS41IFogTTkuMzEwMzk3OTYsMTMuNSBMNS42ODk2MDIwNCwxMy41IEM2LjM3OTMxNzk1LDE1LjUxMDg0OSA3LjA0MDIwMzMsMTYuNSA3LjUsMTYuNSBDNy45NTk3OTY3LDE2LjUgOC42MjA2ODIwNSwxNS41MTA4NDkgOS4zMTAzOTc5NiwxMy41IFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcuNTAwMDAwLCA4LjUwMDAwMCkgcm90YXRlKDM1LjAwMDAwMCkgdHJhbnNsYXRlKC03LjUwMDAwMCwgLTguNTAwMDAwKSAiPjwvcGF0aD4NCiAgICAgICAgICAgICAgICAgICAgPC9nPg0KICAgICAgICAgICAgICAgIDwvZz4NCiAgICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg==');

        &_apply {
          cursor: pointer;
          width: 13px;
          height: 18px;
          background-position: 0 0;
          background-repeat: no-repeat;
          background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjEzcHgiIGhlaWdodD0iMThweCIgdmlld0JveD0iMCAwIDEzIDE4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBza2V0Y2h0b29sIDU1LjIgKDc4MTgxKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4NCiAgICA8dGl0bGU+QkQ3OTdFNUQtQUY2NC00MTZELUE5RDItQ0QwMzRFODhGREE4QDEsNXg8L3RpdGxlPg0KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4NCiAgICA8ZyBpZD0iUGFnZS00IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4NCiAgICAgICAgPGcgaWQ9Ik1haW5fcGxhaW5fb3Blbl9mb3JtdWxhIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTI1NC4wMDAwMDAsIC0yMjEuMDAwMDAwKSIgZmlsbD0iIzAyREZCMCIgc3Ryb2tlPSIjNjA4OUU3Ij4NCiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMjYxLjYxMDY2LDIzNy4wNDU5OTggQzEyNjEuNjA2MTMsMjM3LjA0MTU5MyAxMjYxLjYwMzg3LDIzNy4wMzkzNTUgMTI2MS41OTYxOSwyMzcuMDMxNzI4IEwxMjU1LjkzOTM0LDIzMS4zNzQ4NzQgQzEyNTUuMzUzNTUsMjMwLjc4OTA4NyAxMjU1LjM1MzU1LDIyOS44MzkzNCAxMjU1LjkzOTM0LDIyOS4yNTM1NTMgQzEyNTYuNTI1MTMsMjI4LjY2Nzc2NyAxMjU3LjQ3NDg3LDIyOC42Njc3NjcgMTI1OC4wNjA2NiwyMjkuMjUzNTUzIEwxMjYxLjE4NTc5LDIzMi4zNzg2OCBMMTI2MS4xODU3OSwyMjIgQzEyNjEuMTg1NzksMjIxLjE3MTU3MyAxMjYxLjg1NzM2LDIyMC41IDEyNjIuNjg1NzksMjIwLjUgQzEyNjMuNTE0MjEsMjIwLjUgMTI2NC4xODU3OSwyMjEuMTcxNTczIDEyNjQuMTg1NzksMjIyIEwxMjY0LjE4NTc5LDIzNiBDMTI2NC4xODU3OSwyMzYuODI4NDI3IDEyNjMuNTE0MjEsMjM3LjUgMTI2Mi42ODU3OSwyMzcuNSBDMTI2Mi4yNzU2NywyMzcuNSAxMjYxLjg5MDgyLDIzNy4zMzM5MzUgMTI2MS42MTA2NiwyMzcuMDQ1OTk4IFogTTEyNjEuMTg1NzksMjMyLjM3ODY4IEwxMjYyLjAzOTM0LDIzMy4yMzIyMzMgTDEyNjEuMTg1NzksMjMzLjU4NTc4NiBMMTI2MS4xODU3OSwyMzIuMzc4NjggWiIgaWQ9IkNvbWJpbmVkLVNoYXBlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMjU5Ljg0Mjg5MywgMjI5LjAwMDAwMCkgcm90YXRlKDIwLjAwMDAwMCkgdHJhbnNsYXRlKC0xMjU5Ljg0Mjg5MywgLTIyOS4wMDAwMDApICI+PC9wYXRoPg0KICAgICAgICA8L2c+DQogICAgPC9nPg0KPC9zdmc+');
        }
      }

      &__delete {
        width: 13px;
        height: 13px;
        background-position: 0 0;
        background-repeat: no-repeat;
        background-image: url('data:image/svg+xml;base64,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');
        cursor: pointer;
        margin-right: 10px;
      }

      &__sign-equally {
        padding: 0 10px;
      }
    }
  }

  &-footer {

  }
}
</style>
